import { useQuery } from '@tanstack/react-query';
import { fetchBundledPlugins } from '@api/marketplace';
import { formatApiError } from '@api/common/errors';
import { getQueryAlertMessages } from '../formatters/alerts';
import { toPluginModel } from './to-plugin-model';
const keys = {
    plugins: ['bundled-plugins']
};
export function useBundledPlugins(enabled = true) {
    return useQuery({
        queryKey: keys.plugins,
        queryFn: () => fetchBundledPlugins().then(response => response.map(plugin => toPluginModel(plugin.xmlId, 'BUNDLED', plugin.name))),
        placeholderData: [],
        staleTime: Infinity,
        enabled,
        meta: getQueryAlertMessages(error => formatApiError(error, 'Failed to load bundled plugins'))
    });
}
